import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import bocaRaton__asset from "@/assets/restore/locations/boca-raton.jpg.asset.json";
import jacksonville__asset from "@/assets/restore/locations/jacksonville.jpg.asset.json";
import miami__asset from "@/assets/restore/locations/miami.jpg.asset.json";
import tampa__asset from "@/assets/restore/locations/tampa.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Boca Raton",
    serviceArea: "boca-raton",
    address: "2255 Glades Road, Suite 324A",
    img: bocaRaton__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=2255+Glades+Road+Boca+Raton+FL",
    to: "/locations/florida/boca-raton/",
  },
  {
    name: "Jacksonville",
    serviceArea: "jacksonville",
    address: "4651 Salisbury Rd, Suite 400",
    img: jacksonville__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=4651+Salisbury+Rd+Jacksonville+FL",
    to: "/locations/florida/jacksonville/",
  },
  {
    name: "Miami",
    serviceArea: "miami",
    address: "80 SW 8th St, Suite 2000",
    img: miami__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=80+SW+8th+St+Miami+FL",
    to: "/locations/florida/miami/",
  },
  {
    name: "Tampa",
    serviceArea: "tampa",
    address: "8875 Hidden River Pkwy, Suite 300",
    img: tampa__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=8875+Hidden+River+Pkwy+Tampa+FL",
    to: "/locations/florida/tampa/",
  },
];

export const Route = createFileRoute("/locations/florida/")({
  head: () => ({
    meta: [
      { title: "Florida Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Florida. Find our Boca Raton, Jacksonville, Miami, and Tampa locations for a free personal hair loss consultation.",
      },
      { property: "og:title", content: "Florida Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across Florida and book a free consultation in Boca Raton, Jacksonville, Miami, or Tampa.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/florida/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/florida/" }],
  }),
  component: () => <StateLocationsHub stateName="Florida" cities={cities} />,
});